import { UNIT } from '../../../../constant/unit'
import { appMessages as messages } from '../../../../messages'
import { PROFILE_KEY } from '../../constants'
import createValidationElementUtil from '../../../../modules/redux/utils/create-validation-element'
import { getValueReduxUtil } from '../../../../modules/redux/utils/get-value'

function weightImperial (value) {
  if (value < 5) {
    return createValidationElementUtil(
      PROFILE_KEY.WEIGHT, messages.minimum, {
        key: PROFILE_KEY.WEIGHT,
        min: 5
      }
    )
  }
  if (value > 1400) {
    return createValidationElementUtil(
      PROFILE_KEY.WEIGHT, messages.maximum, {
        key: PROFILE_KEY.WEIGHT,
        max: 1400
      }
    )
  }
  return true
}

function weightMetric (value) {
  if (value < 5) {
    return createValidationElementUtil(
      PROFILE_KEY.WEIGHT, messages.minimum, {
        key: PROFILE_KEY.WEIGHT,
        min: 5
      }
    )
  }
  if (value > 630) {
    return createValidationElementUtil(
      PROFILE_KEY.WEIGHT, messages.maximum, {
        key: PROFILE_KEY.WEIGHT,
        max: 630
      }
    )
  }
  return true
}

function weightProfileValidatorUtil (value, options) {
  const { instance } = options
  const weightUnit = getValueReduxUtil(instance, PROFILE_KEY.WEIGHT_UNIT)
  if (typeof value === 'string') {
    value = parseFloat(value)
  }
  if (weightUnit === UNIT.IMPERIAL) {
    return weightImperial(value)
  }
  return weightMetric(value)
}

export default weightProfileValidatorUtil
